class LoginDetails {
  constructor(email, password) {
    this.username = email;
    this.password = password;
  }
}

export { LoginDetails };
